export const brand = {
  productName: "Swagan Copy Cloud",
  shortName: "SCC",
  tagline: "Institutional multi-tenant copy-trading control plane",
  environmentLabel: "Authenticated · Read-only · Simulation",
  supportEmail: "support@example.com",
  logoText: "SCC",
  /** Reserved for future rename without UI rewrite */
  alternateProductName: "TradeBridge Cloud",
} as const;

export type BrandConfig = typeof brand;
